import PropTypes from "prop-types";
import { SortableElement } from "react-sortable-hoc";
import { FolderBookmark } from "./FolderBookmark";
import { LinkBookmark } from "./LinkBookmark";
import { isBookmarkFolder } from "./helpers/bookmark_helper";

export const SortableItem = SortableElement(({ bookmark }) => {
  const isFolder = isBookmarkFolder(bookmark);

  return (
    <div className="bg-primary hover:text-dark hover:bg-tertiary text-default z-20 flex rounded-md transition-colors">
      {isFolder ? (
        <FolderBookmark bookmark={bookmark} />
      ) : (
        <LinkBookmark bookmark={bookmark} />
      )}
    </div>
  );
});

SortableItem.propTypes = {
  bookmark: PropTypes.object.isRequired,
};
